import { getDefaultState } from "./state";

export default {
  setLoading(state, load) {
    state.loading = load;
  },
  // need to check why is this (auth)
  setUser: (state, user) => {
    state.user = user;
  },

  SET_ALL_SMS_LIST(state, { smses, total, per_page }) {
    state.smses = smses;
    state.totalPage = total / per_page;
    state.totalItems = total;
  },

  SET_SMS_RECIPIENT_REPORT(state, { smsRecipientReport, total, per_page }) {
    state.smsRecipientReport = smsRecipientReport;
    state.recipientReportTotalPage = total / per_page;
    state.recipientReportTotalItems = total;
  },

  UPDTE_SMS_RECIPIENT_REPORT(state, smsRecipientReport) {
    state.smsRecipientReport = [
      ...state.smsRecipientReport,
      smsRecipientReport,
    ];
    // state.smsRecipientReport.push(smsRecipientReport);
  },

  SET_LAST_SMS(state, sms) {
    state.lastSms = sms;
  },

  UPATE_ACTIVE_RECIPIENT(state, recipient) {
    state.activeRecipient = recipient;
  },

  UPDATE_CURRENT_MESSAGE_LIST(state, messages) {
    state.currentMessageList = messages;
  },

  UPDATE_UNREAT_COUNT(state, i) {
    state.unreadCount = state.unreadCount + i;
  },

  SET_SMS_REPORT(state, { smsReport, total, per_page }) {
    state.smsReport = smsReport;
    state.smsReportTotalPage = total / per_page;
    state.smsReportTotalItems = total;
  },

  SET_SMS_RESELLER_REPORT(state, { smsResellerReport, total, per_page }) {
    state.smsResellerReport = smsResellerReport;
    state.smsResellerTotalPage = total / per_page;
    state.smsResellerTotalItems = total;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};
